import React, { useState, useEffect } from 'react';
import MasterService from '../../services/MasterService';

const StatusHistoryPopup = ({ uploadProofId, handleClose }) => {
    const [history, setHistory] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (uploadProofId) {
            fetchHistory();
        }
    }, [uploadProofId]);

    const fetchHistory = async () => {
        setLoading(true);
        try {
            const response = await MasterService.getStatusHistory(uploadProofId);
            if (response && response.data) {
                setHistory(response.data);
            }
        } catch (err) {
            console.error('Error fetching status history:', err);
            setError('Failed to fetch transaction history');
        } finally {
            setLoading(false);
        }
    };

    const formatDateTime = (dateString) => {
        const date = new Date(dateString);
        return {
            date: date.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' }),
            time: date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true })
        };
    };

    const getStatusText = (item) => {
        const moduleLabel = item.module === 'BANK_MATCH' ? 'Bank Match Status' : 'Loan Assigned Status';
        const labels = {
            '0': 'No action',
            '1': 'Partial Match',
            '2': 'System Match',
            '3': 'Manual Match',
            '4': 'Not Matched'
        };
        const statusLabel = labels[item.uploadProofStatus] || item.uploadProofStatus;
        
        let detailText = '';
        if (item.value) {
            // If there's extra info like "Updated from 1234 to 3456"
            detailText = ` (${item.value})`;
        }
        
        return `${moduleLabel}: ${statusLabel}${detailText}`;
    };

    return (
        <div className="status-history-modal">
            <div className="history-header">
                <h3>Transaction History</h3>
                <button className="close-btn" onClick={handleClose}>
                    <i className="ic-clearclose"></i>
                </button>
            </div>
            
            <div className="history-body">
                {loading && (
                    <div className="text-center p-4">
                        <div className="spinner-border spinner-border-sm" role="status"></div>
                    </div>
                )}
                
                {error && <div className="alert alert-danger mx-3">{error}</div>}
                
                {!loading && history.length === 0 && (
                    <div className="text-center p-4 text-muted">No history found</div>
                )}
                
                <div className="history-timeline">
                    {history.map((item, index) => {
                        const { date, time } = formatDateTime(item.createdAt);
                        return (
                            <div key={item.id || index} className="timeline-item">
                                <div className="timeline-time">
                                    <span className="date">{date}</span>
                                    <span className="time">{time}</span>
                                </div>
                                <div className="timeline-content">
                                    <div className="content-box">
                                        <p className="status-title">{getStatusText(item)}</p>
                                        <p className="action-by">{item.actionBy}</p>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default StatusHistoryPopup;
